import * as React from "react";
import { Button as MuiButton } from "@mui/material";
import { classNames } from "utils";
import { Link } from "react-router-dom";

export default function Button({
  label,
  type,
  handleClick,
  disabled,
  otherClass,
  gradient,
  fullWidth,
  link,
  color = "primary",
  variant = "contained",
  size,
  Icon,
  state,
  isSubmitting,
}) {
  return (
    <MuiButton
      color={color}
      variant={variant}
      {...(link && { component: Link, to: link, state })}
      {...(handleClick && { onClick: handleClick })}
      {...(type && { type })}
      {...(size && { size })}
      disabled={disabled || isSubmitting}
      classes={{
        disabled: gradient ? "!text-white/50 dark:!text-white/90" : "",
      }}
      className={classNames(
        gradient
          ? "bg-gradient-to-r from-button_gradient_from to-button_gradient_to"
          : variant === "contained"
          ? ""
          : "",
        // !font-bold
        fullWidth ? "w-full" : "",
        //
        "!min-w-auto h-[36px] !rounded !text-sm  !capitalize",
        otherClass
      )}
    >
      {!isSubmitting ? (
        <>{Icon ? <Icon className="iconShadow" /> : label}</>
      ) : (
        <div>Loading</div>
      )}
    </MuiButton>
  );
}
